<template>

  <div>

    <h2 style="display: inline;">{{$t('title.controller-details')}}: {{ controller.name }} </h2>
    <!-- <p style="display: inline;">{{ controller.description }}</p> -->

    <el-tabs>

      <el-tab-pane :label="$t('tab.controller-details')">

        <el-row :gutter="30">

          <el-col :span="12">
            <controller-form :controller="controller" />
          </el-col>

        </el-row>

      </el-tab-pane>

      <el-tab-pane :label="$t('tab.controller-diagnosis')">

        <controller-diagnosis :controller="controller" />

      </el-tab-pane>

      <el-tab-pane :label="$t('tab.switches')">

        <el-row :gutter="30">

          <el-col v-for="(switchx, i) in switches" :span="12">

            <h2>{{ i + 1 }}. {{ $t('switch') }}</h2>

            <switch-form :switchx="switchx" />
            <server-switch-form :switchx="switchx" />

          </el-col>

        </el-row>

      </el-tab-pane>

      <el-tab-pane :label="$t('tab.controller-wifi-settings')">

        <el-row :gutter="30">

          <el-col :span="12">

            <controller-wifi-setting :controller="controller"/>

          </el-col>

        </el-row>

      </el-tab-pane>

      <el-tab-pane :label="$t('tab.readers')">

        <el-row :gutter="30">

          <el-col v-for="reader in relatedReaders" :span="12">

            <reader-form :reader="reader" />

          </el-col>

        </el-row>

      </el-tab-pane>

      <el-tab-pane :label="$t('tab.inputs')">

        <el-row :gutter="30">

          <el-col v-for="input in relatedInputs" :key="input.id" :span="12">

            <input-form :input="input" />

          </el-col>

        </el-row>

      </el-tab-pane>

      <el-tab-pane :label="$t('tab.in-progress-accesses')">

        <el-row :gutter="30">

          <el-col :span="12">

            <data-table
              :model="unprocessedAccesses"
              :columns="['contact_name', 'switch.name', 'attempts', '[T]key_type']"
            />

          </el-col>

        </el-row>

      </el-tab-pane>

      <el-tab-pane :label="$t('tab.tx-power')">

        <el-row :gutter="30">

          <el-col :span="12">

            <controller-tx-power :controller="controller" />

          </el-col>

        </el-row>

      </el-tab-pane>

      <el-tab-pane :label="$t('tab.command')">

        <el-row :gutter="30">

          <el-col :span="12">

            <command-builder :controller="controller" />

          </el-col>

        </el-row>

      </el-tab-pane>

    </el-tabs>

  </div>

</template>

<script>
import ControllerForm from 'components/controller/ControllerForm.vue'
import ServerSwitchForm from 'components/switch/ServerSwitchForm'
import SwitchForm from 'components/switch/SwitchForm'
import ReaderForm from 'components/reader/ReaderForm.vue'
import InputForm from 'components/input/InputForm.vue'
import ControllerWifiSetting from 'components/wifi-setting/ControllerWifiSetting'
import ControllerDiagnosis from 'components/controller/ControllerDiagnosis.vue'
import CommandBuilder from 'components/command/CommandBuilder.vue'
import ControllerTxPower from 'components/controller/ControllerTxPower.vue'

import findAll from 'service/findAll'
import findOne from 'service/findOne'

export default {
  name: 'controller-details',
  computed: {
    controllerId () { return this.$route.params.id }
  },
  mixins: [
    findAll('mobiles'),
    findAll('preregistrations'),
    findOne('controllers', 'controller', function () { return this.controllerId }),
    findAll('readers', 'relatedReaders', {
      filter (r) { return r.controller_id === this.$route.params.id }
    }),
    findAll('inputs', 'relatedInputs', {
      filter (i) { return i.controller_id === this.$route.params.id }
    }),
    findAll('switches', {
      filter (s) { return s.controller_id === this.$route.params.id }
    }),
    findAll('pending-mobile-accesses', 'unprocessedAccesses', {
      filter (access) {
        if (!this.controller || !this.controller.switches) {
          return false
        }

        return this.controller.switches.map(s => s.id).includes(access.switch_id)
      },
      map (access) {
        return {
          ...access,
          key_type: 'keyType.' + access.key_type,
          switch: this.controller.switches.find(s => s.id === access.switch_id)
        }
      }
    })
  ],
  components: {
    ServerSwitchForm,
    SwitchForm,
    ControllerWifiSetting,
    ReaderForm,
    InputForm,
    ControllerDiagnosis,
    ControllerForm,
    CommandBuilder,
    ControllerTxPower
  }
}
</script>



// WEBPACK FOOTER //
// ControllerDetails.vue?1fb509ac